import React from 'react';
export function BlobBackground({
  className = '',
  color = 'var(--color-mint)'
}: {
  className?: string;
  color?: string;
}) {
  return <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-11">
      <path fill={color} d="M44.7,-76.4C58.9,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.9,-18.1,97.4,-2.5C97.9,13.1,92.8,28.9,83.3,42.1C73.8,55.3,59.9,65.9,44.6,73.1C29.3,80.3,12.6,84.1,-3.6,89.2C-19.8,94.3,-35.5,100.7,-49.8,95.6C-64.1,90.5,-77,73.9,-84.9,56.1C-92.8,38.3,-95.7,19.3,-94.1,1.1C-92.5,-17.1,-86.4,-34.2,-76.2,-48.5C-66,-62.8,-51.7,-74.3,-36.5,-80.6C-21.3,-86.9,-5.2,-88,10.2,-84.5C25.6,-81,40.5,-72.9,44.7,-76.4Z" transform="translate(100 100)" data-id="element-12" />
    </svg>;
}